import React from "react";
import { Box } from '@material-ui/core';
import { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

function YouTubePlayer({ videoId, autoplay = false }) {
    const [isClient, setIsClient] = useState(false);

    const ref = useRef();

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return <></>;
    }

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                aspectRatio: '16/9',
                iframe: {
                    display: 'block',
                },
            }}
        >
            <ReactPlayer
                url={`https://www.youtube.com/embed/${videoId}?rel=0`}
                config={{
                    youtube: {
                        playerVars: {
                            autoplay,
                        },
                    },
                }}
                width="100%"
                height="100%"
                controls={true}
                ref={ref}
                onEnded={() => {
                    ref.current.seekTo(0);
                }}
            />
        </Box>
    );
}

export default YouTubePlayer;
